export const comboDefOrganisations = {
    collection: 'organisations_view_gridCombo',
    select: 'ID, FieldValue',
    top: '500',
    where: '',
    groupby: '',
    orderby: 'FieldValue',
    with0: 'true',
};
  